import Tool, { type IToolActionInput, type IToolAvailableInput } from './Tool';
import { isSimpleSelection } from '../objects/guards';
import Shortcut from '../utils/Shortcut';

class ToolSendBackwards extends Tool {
  static toolName = 'Send backwards';
  static shortcut = new Shortcut('Shift+pagedown');

  static action({ controller, selection }: IToolActionInput) {
    selection.sendBackwards();
    this.toolActionComplete({ controller });
  }

  static available({ selection }: IToolAvailableInput) {
    return !!(
      selection &&
      selection.type !== 'comment' &&
      !isSimpleSelection(selection)
    );
  }
}

export default ToolSendBackwards;
